// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2S4O9","log":"ModalInventoryLogs_log__2tN8A","date":"ModalInventoryLogs_date__N8zt9","userName":"ModalInventoryLogs_userName__3zP32"};